/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_NInputs */

const en_tut_paket_n = /** @type {(inputs: Tut_Paket_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the workspace owner can cancel a subscription, and cancellation takes effect at the end of the period — the plan stays active until that date, then falls back to Free. **Unduh log** saves the action history as CSV.`)
};

const id_tut_paket_n = /** @type {(inputs: Tut_Paket_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pemilik workspace yang bisa membatalkan langganan, dan pembatalan berlaku di akhir periode — paket tetap aktif sampai tanggal itu, lalu kembali ke Gratis. **Unduh log** menyimpan riwayat tindakan sebagai CSV.`)
};

/**
* | output |
* | --- |
* | "Only the workspace owner can cancel a subscription, and cancellation takes effect at the end of the period — the plan stays active until that date, then fall..." |
*
* @param {Tut_Paket_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_n = /** @type {((inputs?: Tut_Paket_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_n(inputs)
	return en_tut_paket_n(inputs)
});